import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { request } from "../../utils/axios-utils";
import parse from "html-react-parser";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import { awardimg, businessban, dropdownarrow, raymondimg } from "../../images";
import RightArrowButton from "../../components/RightArrowButton/RightArrowButton";
import "./OurBusiness.scss";
import Loader from "../../components/Loader/Loader";
import { businessImageUrl } from "../../helpers/utils";
// import { useLocation } from "react-router-dom";
import { Fade } from "react-awesome-reveal";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import MetaDecorator from "../../components/MetaDecorator/MetaDecorator";

const bannerArr = [
  {
    id: 1,
    img: businessban,
    firsthead: "HOME | OUR BUSINESSES",
    heading: "Our Businesses",
    desc: "Raymond Limited ......."
  },
];

const businessTabArr = [
  {
    tabName: "tab1",
    list: [
      {
        desc: "hello",
      },
    ],
  },
  {
    tabName: "tab2",
    list: [
      {
        desc: "hello",
      },
    ],
  },
  {
    tabName: "tab3",
    list: [
      {
        desc: "hello",
      },
    ],
  },
  {
    tabName: "tab4",
    list: [
      {
        desc: "hello",
      },
    ],
  },
  {
    tabName: "tab5",
    list: [
      {
        desc: "hello",
      },
    ],
  },
];

const businessArr = [
  {
    id: 1,
    img: raymondimg,
    list: {
      title: "Raymond",
      desc: "Raymond is a diversified group with majority Brand Raymond has pushed the benchmarks of quality, leadership and extraordinary product across fashion. leadership and extraordinary product across fashion",
    },
  },
  {
    id: 2,
    img: raymondimg,
    list: {
      title: "Raymond",
      desc: "Raymond is a diversified group with majority Brand Raymond has pushed the benchmarks of quality, leadership and extraordinary product across fashion. leadership and extraordinary product across fashion",
    },
  },
];

const fetchBusinesseData = () => {
  return request({ url: "/businesses", method: "get" });
};
const OurBusiness = () => {
  // const location = useLocation();
  // const boxId = location.state?.boxId;
  const { width } = useWindowDimensions();
  const [businessDataArr, setBusinessDataArr] = useState([]);
  const [businessIndex, setBusinessIndex] = useState(0);

  const brandArr = [
    
    {
      "_id": "62fce8bc1d7fb152e7de4604",
      "title": "Realty",
      "description": "<p><span style=\"font-weight: 400;\">Incepted in the year 2019 with the development of a small piece of land in Thane, Raymond Realty is shaping the lifestyle landmarks with a whole new idea of space, privacy, and luxury. With distinct advantages of offering the right product, at the right price and location, </span><span style=\"font-weight: 400;\">Raymond Realty is reckoned as one of the best-selling real estate projects across Mumbai within a short span of its time.</span></p>",
      "image": "1673011619670772 × 537.jpg",
      "website": "/our-brand/raymond-realty",
      "status": 1,
      "sort_order": 3,
      "createdAt": "2022-08-17T13:10:20.180Z",
      "updatedAt": "2023-01-06T13:47:55.096Z",
      "__v": 0
    },
    {
      "_id": "62fce9321d7fb152e7de4621",
      "title": "Engineering (Tools, Auto and Aerospace)",
      "description": "<p><span style=\"font-weight: 400;\">The Raymond Group ventured into the engineering business with high-performance products and cutting-edge solutions, empowering one to achieve excellence.</span></p>",
      "image": "16607430485851656857389816Jk Files & Engineering (1).jpg",
      "website": "/our-brand/jk-files-engineering",
      "status": 1,
      "sort_order": 4,
      "createdAt": "2022-08-17T13:12:18.331Z",
      "updatedAt": "2023-12-08T10:35:50.737Z",
      "__v": 0
    },
    {
      "_id": "62fceaa21d7fb152e7de4662",
      "title": "Denim",
      "description": "<p><span style=\"font-weight: 400;\">A formidable player in the denim category, Raymond is amongst the leading producer &amp; preferred suppliers of high-quality Ring Denim to the world&rsquo;s renowned Jeanswear Brands</span><strong>.</strong></p>",
      "image": "16607429681971656857592727UCO Denim (1).jpg",
      "website": "/our-brand/denim",
      "status": 1,
      "sort_order": 6,
      "createdAt": "2022-08-17T13:18:26.243Z",
      "updatedAt": "2022-12-15T09:12:35.062Z",
      "__v": 0
    }
  ];

  const bannerList = bannerArr.map((item, i) => (
    <div className="row" key={i}>
      <div className="col-lg-8">
        {width <= 834 ? (
          <div className="text_container">
            <BreadCrumb linkTwoText={item.heading} linkTwoDisabled />
            <div className="heading">{item.heading}</div>
            <div className="desc">{item.desc}</div>
          </div>
        ) : null}
        <img
          src={'https://oneraymond.in/media/our-business.jpg'}
          alt="raymond business img"
          className="mainimg"
          loading="lazy"
        />
      </div>
      <div className="col-lg-4 flex_box">
        {width > 834 ? (
          <div className="text_container">
            <BreadCrumb linkTwoText={item.heading} linkTwoDisabled />
            <div className="heading">{item.heading}</div>
            <div className="desc">{item.desc}</div>
          </div>
        ) : null}
      </div>
    </div>
  ));

  const businessTabList = (brandArr).map(({ title, _id }, i) => (
    <span
      key={i}
      onClick={() => {
        setBusinessIndex(i);
        scrollToId(_id);
      }}
      className={`business_tab ${businessIndex == i ? "active" : ""} `}
    >
      {title}
    </span>
  ));

  const mbbusinessTabList = brandArr.map(({ title }, i) => (
    <option value={title} key={i} data-awardindexid={i}>
      {title}
    </option>
  ));

  const { isLoading, data: businesseData } = useQuery(
    "businesse-data",
    fetchBusinesseData
  );

  const scrollToId = (_id) => {
    const element = document.getElementById(_id);
    const headerOffset = 210;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    if (businesseData) {
      const {
        data: { data },
      } = businesseData;
      if (data.length > 0) {
        setBusinessDataArr(data);
      }
    }
  }, [businesseData]);

  useEffect(() => {
    // if (boxId) {
    //   const domBoxId = document.getElementById(boxId);
    //   if (boxId === domBoxId?.id) {
    //     applyScroll(boxId, -50);
    //   }
    // }
  }, [businessDataArr]);

  const brandList =
    brandArr.length > 0 ? (
      (brandArr).map(({ title, description, image, website, _id }, i) => (
        <>
          {width > 767 ? (
            <div
              className="col-lg-6 flex_box"
              key={i}
              data-aos="fade-in"
              id={`${_id}`}
            // ref={element1}
            >
              {width <= 834 ? <div className="mobheading">{title}</div> : null}
              <div className="zoomout">
                <img
                  src={businessImageUrl + image}
                  alt="raymond business img"
                  className="mainimg"
                  width={1544}
                  height={1074}
                />
              </div>
              <div className="text_container">
                {width > 834 ? <div className="heading">{title}</div> : null}
                <div className="desc">{parse(description)}</div>
                {website && (
                  <div className="cta_wrapper">
                    <RightArrowButton
                      anchorCta
                      anchorLink={website}
                      target="_self"
                      ctaText="Know More"
                    />
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div
              className={`col-lg-6 flex_box ${businessIndex === i ? "active" : ""
                }`}
              key={i}
              data-aos="fade-in"
              id={`${_id}`}
            // ref={element1}
            >
              {width <= 834 ? <div className="mobheading">{title}</div> : null}
              <div className="zoomout">
                <img
                  src={businessImageUrl + image}
                  alt="raymond business img"
                  className="mainimg"
                  width={1544}
                  height={1074}
                />
              </div>
              <div className="text_container">
                {width > 834 ? <div className="heading">{title}</div> : null}
                <div className="desc">{parse(description)}</div>
                {website && (
                  <div className="cta_wrapper">
                    <RightArrowButton
                      anchorCta
                      anchorLink={website}
                      ctaText="Know More"
                    />
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      ))
    ) : (
      <h3 className="err_message">No Business data found</h3>
    );

  useEffect(() => {
    // window.scrollTo(0, 0);
  });

  if (isLoading) {
    return <Loader />;
  }

  const handleAwardTabChange = (e) => {
    const awardIndexId = e.target.selectedOptions[0].dataset.awardindexid;
    setBusinessIndex(Number(awardIndexId));
  };

  return (
    <>
      <MetaDecorator metaTitle="Welcome to Raymond | Our Businesses" />
      <section className="business_sec1" data-aos="fade-in">
        <div className="my_container">{bannerList}</div>
      </section>

      <section className="business_sec2 extra_space_issue" data-aos="fade-up">
        <div className="my_container">
          {width > 767 ? (
            <div className="business_tabs_wrapper">{businessTabList}</div>
          ) : (
            <div className="business_tabs_wrapper">
              <div className="mb_award_tabs_dropdown_wrapper">
                <select
                  onChange={handleAwardTabChange}
                  className="mb_awards_dropdown"
                >
                  {mbbusinessTabList}
                </select>
                <img
                  src={dropdownarrow}
                  alt="raymond dropdown logo"
                  className="downdropdownarrow"
                />
              </div>
            </div>
          )}
          {width > 767 ? (
            <div className="row">{brandList}</div>
          ) : (
            <div className="row">{brandList}</div>
          )}
        </div>
      </section>
    </>
  );
};

export default OurBusiness;
